/* TUCK Shopify theme JS — cart drawer (AJAX Cart API), goal gate, scratch card, filters, variants */
(function () {
  'use strict';
  var T = window.TUCK || { freeShip: 40, cartCount: 0 };
  var $ = function (id) { return document.getElementById(id); };

  function toast(msg) {
    var t = $('toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function money2(cents) { return '$' + (cents / 100).toFixed(2); }
  /* sticky header + announce bar: expose real header height to CSS */
  function setHdrH() { var h = document.querySelector('.hdr'); if (h) document.documentElement.style.setProperty('--hdr-h', h.offsetHeight + 'px'); }
  window.addEventListener('resize', setHdrH); document.addEventListener('DOMContentLoaded', setHdrH); setHdrH();
  /* dynamic asset URLs need the theme version stamp or the CDN serves stale files */
  function av(u) { return T.assetVer ? u + '?v=' + T.assetVer : u; }
  function safe(fn) { try { fn(); } catch (e) { console.error('[tuck]', e); } }

  /* ── line system: the real range — Energy 80mg / Extra Strength 160mg / Pre-Workout 200mg ── */
  var MODE_SEQ = ['energy', 'xenergy', 'prework'];
  var MODES = {
    energy:  { c: '#4AA3E0', verb: 'And find out.', tag: 'Energy · 80mg',         word: 'Energy',      chip: null, lede: null },
    xenergy: { c: '#1F6FBF', verb: 'Turn it up.', tag: 'Extra Strength · 160mg', word: 'Extra',      chip: '160mg caffeine', lede: 'Extra Strength — a double shot, tucked. 160mg of caffeine per pouch when regular is not enough.' },
    prework: { c: '#202A3C', verb: 'Send it.',   tag: 'Pre-Workout · 200mg',   word: 'Pre-Workout', chip: '200mg caffeine', lede: 'Pre-Workout — gym-grade 200mg per pouch. Take it on the drive so it hits at the rack.' }
  };
  var curMode = null;
  function setMode(m) {
    if (!MODES[m] || m === curMode) return;
    curMode = m;
    var M = MODES[m];
    /* energy uses the merchant's own copy from section settings */
    var lede = $('heroLede'), chip = $('heroChip1');
    if (lede && !lede.dataset.orig) lede.dataset.orig = lede.textContent;
    if (chip && !chip.dataset.orig) chip.dataset.orig = chip.textContent;
    document.documentElement.style.setProperty('--mode', M.c);
    var tag = $('panelTag'); if (tag) tag.textContent = M.tag;
    var can = $('heroCan');
    if (can && T.modeImgs && T.modeImgs[m] && can.getAttribute('src') !== T.modeImgs[m]) {
      can.style.transition = 'opacity .18s ease, transform .18s ease';
      can.style.opacity = '0'; can.style.transform = 'scale(.96)';
      setTimeout(function () {
        var done = function () { can.style.opacity = '1'; can.style.transform = 'scale(1)'; can.removeEventListener('load', done); };
        can.addEventListener('load', done); can.src = T.modeImgs[m];
      }, 180);
    }
    var w = $('shiftWord'); if (w) w.textContent = M.word;
    var i = MODE_SEQ.indexOf(m);
    document.querySelectorAll('#shiftDots i').forEach(function (d, j) { d.classList.toggle('on', j === i); });
  }

  /* ── drop-in entrance (plays when the gate clears) ── */
  function playDrop() {
    var s = $('heroStage'); if (!s || s._dropped) return;
    s._dropped = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { s.classList.remove('pre-drop'); s.classList.add('drop-done'); return; }
    s.classList.remove('pre-drop');
    s.classList.add('drop-play');
    setTimeout(function () { s.classList.remove('drop-play'); s.classList.add('drop-done'); }, 1500);
  }

  /* ── cart drawer over the AJAX Cart API ── */
  function openDrawer() {
    var d = $('cartDrawer'), s = $('cdScrim');
    if (!d) return;
    s.hidden = false; requestAnimationFrame(function () { s.classList.add('show'); d.classList.add('open'); });
    d.setAttribute('aria-hidden', 'false');
    refreshCart();
  }
  function closeDrawer() {
    var d = $('cartDrawer'), s = $('cdScrim');
    if (!d) return;
    s.classList.remove('show'); d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    setTimeout(function () { s.hidden = true; }, 260);
  }
  function renderCart(cart) {
    var box = $('cdItems'); if (!box) return;
    $('cartCount') && ($('cartCount').textContent = cart.item_count);
    $('cdSubtotal') && ($('cdSubtotal').textContent = money(cart.total_price));
    /* shipping: 5- and 10-packs ship free; singles-only orders pay flat shipping */
    var fill = $('shipFill'), msg = $('shipMsg'), bar = $('shipBar'), truck = $('shipTruck'), pctEl = $('shipPct');
    if (fill && msg) {
      var hasPack = cart.items.some(function (it) { return /pack/i.test(it.variant_title || ''); });
      var unlocked = hasPack && cart.item_count > 0;
      fill.style.width = (unlocked ? 100 : (cart.item_count ? 40 : 0)) + '%';
      if (truck) truck.hidden = true;
      if (pctEl) pctEl.textContent = '';
      if (bar) bar.classList.toggle('done', unlocked);
      if (unlocked) msg.textContent = 'Free shipping — packs always ship free';
      else if (cart.item_count) msg.textContent = 'Singles ship $4.99 — any 5-pack ships free';
      else msg.textContent = 'Free shipping on 5- and 10-packs';
    }
    /* upsell state: a bump/rail product already in the cart shows as added */
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id || it.id] = true; });
    document.querySelectorAll('#cdBump, .rail-item').forEach(function (row) {
      var got = inCart[Number(row.dataset.variant)];
      row.classList.toggle('got', !!got);
      var btn = row.querySelector('[data-add]');
      if (btn) { btn.disabled = !!got; btn.textContent = got ? '✓ Added' : (btn.classList.contains('bump-add') ? 'Add' : '+ Add'); }
    });
    if (!cart.items.length) { box.innerHTML = '<p class="cd-empty">Nothing tucked yet.</p>'; return; }
    box.innerHTML = cart.items.map(function (it) {
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var subName = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name) ||
                    (it.properties && it.properties.Subscription) || (it.sub_label || '');
      var optOut = subName ? '<button type="button" class="line-onetime" data-key="' + it.key + '" data-vid="' + (it.variant_id || it.id) + '" data-q="' + it.quantity + '">Switch to one-time · lose 15%</button>' : '';
      if (subName) vt += (vt ? ' · ' : '') + '↻ ' + subName;
      return '<div class="cd-line" data-key="' + it.key + '">' +
        (it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=128" alt="">' : '') +
        '<div class="li"><b>' + it.product_title + '</b><span>' + vt + '</span>' + optOut + '</div>' +
        '<div class="cd-qty"><button type="button" data-cq="-1">−</button><span>' + it.quantity + '</span><button type="button" data-cq="1">+</button></div>' +
        '<span class="lp">' + money(it.final_line_price) + '</span></div>';
    }).join('');
  }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function addToCart(variantId, qty, sub) {
    var body = { id: Number(variantId), quantity: qty || 1 };
    if (sub && sub.plan) body.selling_plan = sub.plan;
    else if (sub && sub.note) body.properties = { 'Subscription': sub.note };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
      return r.json();
    }).then(function () { openDrawer(); toast('Tucked into your cart ✓'); })
      .catch(function (e) { toast(e.message); });
  }
  function changeLine(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart.items.find(function (i) { return i.key === key; });
      if (!it) return;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, it.quantity + delta) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  /* ── goal gate (session-once) + countdown ── */
  var gateDone = false;
  try { gateDone = sessionStorage.getItem('tuckGate') === '1'; } catch (e) {}
  function closeGate(goal) {
    var g = $('goalGate'); if (!g) return;
    g.hidden = true;
    document.body.classList.remove('gated');
    try { sessionStorage.setItem('tuckGate', '1'); } catch (e) {}
    playDrop();
    if (goal) setMode(goal);
  }
  function initGate() {
    playDrop(); return; /* welcome gate retired with the founding offer (v2.8.0) */
    var g = $('goalGate'); if (!g) { playDrop(); armScratch(9000); return; }
    if (gateDone) { playDrop(); armScratch(30000); return; }
    g.hidden = false;
    document.body.classList.add('gated');
    var secs = 120, tEl = $('gateTimer');
    var iv = setInterval(function () {
      secs--; if (secs < 0) { clearInterval(iv); return; }
      if (tEl) tEl.textContent = Math.floor(secs / 60) + ':' + ('0' + secs % 60).slice(-2);
    }, 1000);
  }

  /* ── founding offer state: nothing is "locked" until the card is scratched AND claimed ── */
  function offerClaimed() {
    if (claimFounding._done) return true;
    try { return sessionStorage.getItem('tuckOffer') === '1'; } catch (e) { return false; }
  }
  function applyOfferState() {
    /* founding offer retired: keep the storefront quiet and factual */
    document.querySelectorAll('.club-price').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('.hdr-cta').forEach(function (el) { el.textContent = 'Shop 5-Packs'; el.classList.remove('locked'); });
    document.querySelectorAll('.cd-note').forEach(function (n) {
      n.textContent = 'Your drop renews on your cadence at 15% off — skip, switch any item to one-time above, or cancel anytime.';
    });
  }
  function forceScratch() {
    if (offerClaimed()) return;
    scratchDone = false;
    try { sessionStorage.removeItem('tuckScratch'); } catch (e) {}
    showScratch();
  }

  /* ── scratch card ── */
  var scratchArmed = false, scratchDone = false;
  try { scratchDone = sessionStorage.getItem('tuckScratch') === '1'; } catch (e) {}
  function armScratch(delay) {
    return; /* scratch card retired with the founding offer (v2.8.0) */
    if (scratchArmed || scratchDone || offerClaimed() || !$('popScrim')) return;
    scratchArmed = true;
    setTimeout(showScratch, delay || 8000);
  }
  function showScratch() {
    if (scratchDone || offerClaimed()) return;
    var scrim = $('popScrim'); if (!scrim) return;
    scrim.classList.remove('closing');
    scrim.hidden = false;
    document.body.classList.add('popped');
    initScratchCanvas();
  }
  function hideScratch() {
    var scrim = $('popScrim');
    if (scrim && !scrim.hidden) {
      scrim.classList.add('closing');
      setTimeout(function () { scrim.hidden = true; scrim.classList.remove('closing'); }, 230);
    }
    document.body.classList.remove('popped');
    scratchDone = true;
    try { sessionStorage.setItem('tuckScratch', '1'); } catch (e) {}
  }
  function initScratchCanvas() {
    var cv = $('scratchCanvas'); if (!cv || cv._init) return;
    var w = cv.parentElement.clientWidth;
    if (!w) { setTimeout(initScratchCanvas, 150); return; }
    cv._init = true;
    cv.width = w; cv.height = Math.round(w * 0.375);
    var ctx = cv.getContext('2d');
    var grad = ctx.createLinearGradient(0, 0, w, 0);
    grad.addColorStop(0, '#C7CFDB'); grad.addColorStop(0.5, '#E4E9F1'); grad.addColorStop(1, '#B9C2D0');
    ctx.fillStyle = grad; ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.fillStyle = 'rgba(90,100,120,.55)';
    ctx.font = '700 ' + Math.round(w / 16) + 'px "Bricolage Grotesque",sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('TUCK AROUND', cv.width / 2, cv.height / 2 - 8);
    ctx.font = '600 ' + Math.round(w / 30) + 'px "Bricolage Grotesque",sans-serif';
    ctx.fillText('· AND FIND OUT ·', cv.width / 2, cv.height / 2 + 22);
    ctx.globalCompositeOperation = 'destination-out';
    /* affordance: sweeping shine on the foil until the first touch */
    var wrap = cv.parentElement;
    var shine = document.createElement('i'); shine.className = 'foil-shine';
    wrap.appendChild(shine);
    /* forgiving UX: one good rub (or a second touch) reveals the prize on its own */
    var down = false, revealed = false, strokes = 0, scratched = false, flakeTick = 0;
    function reveal() {
      if (revealed) return; revealed = true;
      shine.classList.add('off');
      cv.style.transition = 'opacity .5s'; cv.style.opacity = '0';
      var pop = document.querySelector('.scratch-pop'); if (pop) pop.classList.add('revealed');
      var claim = $('scratchClaim');
      if (claim) { claim.hidden = false; setTimeout(function () { claim.classList.add('in'); }, 30); }
      /* the coupon becomes tappable only after a beat — otherwise the mouse-release
         from the scratch stroke registers as a click and instantly claims + closes */
      setTimeout(function () { wrap.addEventListener('click', claimFounding); }, 900);
      var hint = document.querySelector('.scratch-hint'); if (hint) hint.textContent = 'Founding offer unlocked';
      toast('$1 a puck — founding offer unlocked');
    }
    function dropFlake(cx, cy) {
      if (++flakeTick % 3 !== 0) return;
      var wr = wrap.getBoundingClientRect();
      var f = document.createElement('i'); f.className = 'flake';
      f.style.left = (cx - wr.left + (Math.random() * 14 - 7)) + 'px';
      f.style.top = (cy - wr.top) + 'px';
      wrap.appendChild(f);
      setTimeout(function () { f.remove(); }, 600);
    }
    function scratch(e) {
      if (revealed) return;
      if (!scratched) { shine.classList.add('off'); }
      var r = cv.getBoundingClientRect();
      var p = e.touches ? e.touches[0] : e;
      var x = (p.clientX - r.left) * (cv.width / r.width);
      var y = (p.clientY - r.top) * (cv.height / r.height);
      ctx.beginPath(); ctx.arc(x, y, 30, 0, Math.PI * 2); ctx.fill();
      dropFlake(p.clientX, p.clientY);
      scratched = true;
      check();
    }
    var checkTick = 0;
    function check() {
      if (revealed || ++checkTick % 4 !== 0) return;
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data, clear = 0;
      for (var i = 3; i < d.length; i += 16) { if (d[i] === 0) clear++; }
      if (clear / (d.length / 16) > 0.10) reveal();
    }
    function endStroke() {
      if (!scratched || revealed) return;
      strokes++;
      /* finish it for them: a beat after their first real rub, or instantly on the second */
      if (strokes >= 2) reveal();
      else setTimeout(reveal, 700);
    }
    cv.addEventListener('mousedown', function (e) { down = true; scratch(e); });
    cv.addEventListener('mousemove', function (e) { if (down) scratch(e); });
    document.addEventListener('mouseup', function () { if (down) { down = false; endStroke(); } });
    cv.addEventListener('touchstart', function (e) { e.preventDefault(); scratch(e); }, { passive: false });
    cv.addEventListener('touchmove', function (e) { e.preventDefault(); scratch(e); }, { passive: false });
    cv.addEventListener('touchend', function () { endStroke(); });
  }
  function claimFounding() { /* retired with the founding offer (v2.8.0) */ }

  /* ── one delegated click handler ── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-add],[data-goal],[data-cq],[data-filter],[data-scroll],.evar,.line-onetime,#cartOpen,#cdClose,#cdContinue,#cdScrim,#burger,.qbtn');
    if (!t) return;

    if (t.id === 'cartOpen') { e.preventDefault(); openDrawer(); return; }
    if (t.id === 'cdClose' || t.id === 'cdContinue' || t.id === 'cdScrim') { closeDrawer(); return; }
    if (t.id === 'burger') { var m = $('mnav'); if (m) m.classList.toggle('open'); return; }
    if (t.id === 'gateSkip') { closeGate(null); return; }

    if (t.dataset.goal) { closeGate(t.dataset.goal); return; }

    if (t.dataset.add) {
      e.preventDefault();
      var noSub = t.closest('#cdBump') || t.hasAttribute('data-onetime');
      addToCart(t.dataset.add, 1, noSub ? null : defaultSub());
      return;
    }

    /* cart-line opt-out: swap a subscribed line to one-time */
    if (t.classList.contains('line-onetime')) {
      var lk = t.dataset.key, lv = t.dataset.vid, lq = Number(t.dataset.q) || 1;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lk, quantity: 0 }) })
        .then(function (r) { return r.json(); })
        .then(function () { return addToCart(lv, lq, null); });
      return;
    }

    if (t.dataset.cq) {
      var line = t.closest('.cd-line');
      if (line) changeLine(line.dataset.key, Number(t.dataset.cq));
      return;
    }

    if (t.classList.contains('evar')) {
      var row = t.closest('.evar-row');
      if (!row) return; /* element re-rendered by another handler on this same click */
      row.querySelectorAll('.evar').forEach(function (b) { b.classList.remove('on'); });
      t.classList.add('on');
      var card = t.closest('.product-card, .pdp-info');
      if (card) {
        /* flavor dot with a dual pack mapping (PDP): resolve against the selected pack */
        if (t.dataset.v5) {
          card.dataset.flavorV5 = t.dataset.v5; card.dataset.flavorV1 = t.dataset.v1 || t.dataset.v5;
          card.dataset.flavorP5 = t.dataset.p5 || ''; card.dataset.flavorP1 = t.dataset.p1 || '';
          var packOn = card.querySelector('.ppill.on');
          var five = !packOn || packOn.dataset.pack === '5';
          t.dataset.variant = five ? t.dataset.v5 : t.dataset.v1;
          t.dataset.price = five ? t.dataset.p5 : t.dataset.p1;
          t.dataset.per = five ? '/ 5-pack' : '/ can';
        }
        /* pack pill on a page that also has flavor dots */
        if (t.classList.contains('ppill') && card.dataset.flavorV5) {
          var f5 = t.dataset.pack === '5';
          t.dataset.variant = f5 ? card.dataset.flavorV5 : card.dataset.flavorV1;
          t.dataset.price = f5 ? card.dataset.flavorP5 : card.dataset.flavorP1;
          t.dataset.per = f5 ? '/ 5-pack' : '/ can';
        }
        var priceEl = card.querySelector('.price-now'); if (priceEl && t.dataset.price) priceEl.textContent = t.dataset.price;
        var perEl = card.querySelector('.per'); if (perEl && t.dataset.per) perEl.textContent = t.dataset.per;
        var add = card.querySelector('.card-add'); if (add && t.dataset.variant) add.dataset.add = t.dataset.variant;
        var hid = card.querySelector('#pdpVariantId'); if (hid && t.dataset.variant) hid.value = t.dataset.variant;
        var sp = $('stickyPrice'); if (sp && hid && t.dataset.price) sp.textContent = t.dataset.price;
        if (hid && t.dataset.price && typeof syncSubPrices === 'function') syncSubPrices(t.dataset.price);
        /* flavor dots swap the render */
        if (t.dataset.img) {
          var im = card.querySelector('.prod-img') || document.querySelector('#pdpMedia .prod-img, .pdp-media .prod-img');
          if (!im) { var tin = t.closest('.product-card'); im = tin && tin.querySelector('.prod-img'); }
          if (im) im.src = t.dataset.img;
        }
      }
      return;
    }

    if (t.dataset.filter) {
      document.querySelectorAll('.filt').forEach(function (b) { b.classList.remove('on'); });
      t.classList.add('on');
      if (window.TUCKFiltInd) window.TUCKFiltInd();
      var f = t.dataset.filter;
      document.querySelectorAll('#shopGrid .grid-cell').forEach(function (c) {
        c.classList.toggle('hide', f !== 'all' && c.dataset.mode !== f);
      });
      return;
    }

    if (t.hasAttribute('data-scroll')) {
      var hash = (t.getAttribute('href') || '').split('#')[1];
      var target = hash && document.getElementById(hash);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
      else if (hash && location.pathname !== '/') { location.href = '/#' + hash; e.preventDefault(); }
      var m2 = $('mnav'); if (m2) m2.classList.remove('open');
      return;
    }

    if (t.classList.contains('qbtn')) {
      var q = $('pdpQty');
      if (q) q.value = Math.max(1, Number(q.value) + Number(t.dataset.q));
      return;
    }
  });

  /* subscription-first: every add defaults to Subscribe & Save unless explicitly opted out */
  function defaultSub() { return { note: 'Every 4 weeks · Save 15%' }; }

  /* PDP: subscribe & save state */
  function subState() {
    var on = document.querySelector('.sub-opt.on');
    if (!on || on.dataset.sub !== '1') return null;
    var sel = $('subPlan');
    var cadence = sel ? sel.options[sel.selectedIndex].textContent : '4 weeks';
    if (sel && sel.value) return { plan: sel.value };
    return { note: 'Every ' + cadence + ' · Save 15%' };
  }
  /* keep the form's selling_plan input matched to the toggle, so Shop Pay /
     dynamic checkout buys the subscription too; disabled = one-time */
  function syncPlanInput() {
    var hid = $('pdpSellingPlan'); if (!hid) return;
    var s = subState();
    if (s && s.plan) { hid.value = s.plan; hid.disabled = false; }
    else { hid.value = ''; hid.disabled = true; }
  }
  function syncSubPrices(priceStr) {
    var one = $('onePrice'), sub = $('subPrice');
    if (!one || !priceStr) return;
    one.textContent = priceStr;
    var cents = Math.round(parseFloat(priceStr.replace(/[^0-9.]/g, '')) * 100);
    if (sub && cents) sub.textContent = money(Math.round(cents * 0.85));
    applySubPrice();
  }
  function applySubPrice() {
    /* the big price is always the pack price; the sub price lives on its own line */
    var main = document.querySelector('.pdp-info .price-now');
    var one = $('onePrice'), sub = $('subPrice'), sl = $('pdpSubLine');
    if (main && one) main.textContent = one.textContent;
    var sp = $('stickyPrice'); if (sp && one) sp.textContent = one.textContent;
    if (sl && sub) {
      var subOpt = document.querySelector('.sub-opt[data-sub="1"]');
      var locked = subOpt && subOpt.classList.contains('sub-locked');
      var on = subOpt && subOpt.classList.contains('on');
      sl.hidden = !!locked;
      if (!locked) sl.textContent = on ? 'Subscribed: ' + sub.textContent + ' per drop · saving 15%' : 'or ' + sub.textContent + ' per drop with Subscribe & Save';
    }
  }
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.sub-opt');
    if (!opt) return;
    document.querySelectorAll('.sub-opt').forEach(function (o) { o.classList.toggle('on', o === opt); });
    var r = opt.querySelector('input'); if (r) r.checked = true;
    applySubPrice();
    syncPlanInput();
  });
  safe(function () { var ps = $('subPlan'); if (ps) ps.addEventListener('change', syncPlanInput); });

  /* PDP form → AJAX add + drawer */
  var pdpForm = $('pdpForm');
  if (pdpForm) pdpForm.addEventListener('submit', function (e) {
    e.preventDefault();
    addToCart($('pdpVariantId').value, Number(($('pdpQty') || {}).value || 1), subState());
  });

  /* PDP: frequently bought together */
  safe(function () {
    var totalEl = $('fbtTotal'); if (!totalEl) return;
    function fbtTotal() {
      var cents = Number((document.querySelector('.fbt-this') || { dataset: {} }).dataset.cents) || 0;
      document.querySelectorAll('.fbt-check:checked').forEach(function (c) { cents += Number(c.dataset.cents) || 0; });
      totalEl.textContent = money(cents);
    }
    document.querySelectorAll('.fbt-check').forEach(function (c) { c.addEventListener('change', fbtTotal); });
    fbtTotal();
    var btn = $('fbtAdd');
    if (btn) btn.addEventListener('click', function () {
      var ids = [$('pdpVariantId') ? $('pdpVariantId').value : null].filter(Boolean);
      document.querySelectorAll('.fbt-check:checked').forEach(function (c) { ids.push(c.dataset.variant); });
      var chain = Promise.resolve();
      ids.forEach(function (id, i) { chain = chain.then(function () { return addToCart(id, 1, i === 0 ? subState() : defaultSub()); }); });
    });
  });

  /* PDP: image gallery slider (arrows, thumbnails, swipe) */
  safe(function () {
    var track = $('pdpTrack'); if (!track) return;
    var slides = track.children.length, idx = 0;
    var thumbs = $('psThumbs');
    function go(n) {
      idx = (n + slides) % slides;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      if (thumbs) { Array.prototype.forEach.call(thumbs.children, function (t, j) { t.classList.toggle('on', j === idx); }); }
    }
    if (thumbs && slides > 1) {
      Array.prototype.forEach.call(track.querySelectorAll('img'), function (im, j) {
        var th = document.createElement('button');
        th.type = 'button'; th.className = 'ps-thumb' + (j === 0 ? ' on' : '');
        th.setAttribute('aria-label', 'Image ' + (j + 1));
        th.innerHTML = '<img src="' + im.src + '" alt="">';
        th.addEventListener('click', function () { go(j); });
        thumbs.appendChild(th);
      });
    }
    var prev = document.querySelector('.ps-prev'), next = document.querySelector('.ps-next');
    if (slides < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    document.addEventListener('tuck:goslide', function (e) { go(e.detail); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    var sx = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  });

  /* PDP: sticky add-to-cart bar appears once the main button scrolls away */
  safe(function () {
    var sticky = $('pdpSticky'), mainBtn = $('pdpAddBtn') || document.querySelector('.pdp-add');
    if (!sticky || !mainBtn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('on', !entries[0].isIntersecting);
      sticky.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0 }).observe(mainBtn);
    var sAdd = $('stickyAdd');
    if (sAdd) sAdd.addEventListener('click', function () { addToCart($('pdpVariantId').value, Number(($('pdpQty') || {}).value || 1)); });
  });

  /* spots ticker */
  safe(function () {
    var el = $('spotsLeft'); if (!el) return;
    var n = Number(T.spots) || 320;
    setInterval(function () { if (n > 40 && Math.random() < 0.35) { n--; el.textContent = n; } }, 9000);
  });

  /* scroll dynamics: pinned hero scrubs through the five modes, sections reveal as they enter */
  safe(function () {
    var shift = $('heroShift');
    if (shift) {
      /* scroll-jack removed: modes auto-rotate on a timer; dots jump directly */
      var mi = 0, mt = null;
      function mNext() { mi = (mi + 1) % MODE_SEQ.length; setMode(MODE_SEQ[mi]); }
      function mArm() { clearInterval(mt); mt = setInterval(mNext, 3800); }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) mArm();
      shift.addEventListener('mouseenter', function () { clearInterval(mt); });
      shift.addEventListener('mouseleave', function () { if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) mArm(); });
      document.querySelectorAll('#shiftDots i').forEach(function (d, j) {
        d.addEventListener('click', function () { mi = j; setMode(MODE_SEQ[j]); if (mt) mArm(); });
      });
    }
    /* count-up stats when they scroll into view */
    var counters = document.querySelectorAll('.count[data-count]');
    if (counters.length && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          cio.unobserve(en.target);
          var target = Number(en.target.dataset.count) || 0;
          var t0 = performance.now(), dur = 1100;
          var fmt = function (n) {
            if (target >= 1000000) return (n / 1000000).toFixed(1) + 'M';
            if (target < 10 && target !== Math.floor(target)) return n.toFixed(1);
            return Math.round(n).toLocaleString();
          };
          (function tick(now) {
            var p = Math.min((now - t0) / dur, 1);
            en.target.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(tick); else en.target.textContent = fmt(target);
          })(t0);
        });
      }, { threshold: 0.05, rootMargin: '0px 0px 80px 0px' });
      counters.forEach(function (c) { cio.observe(c); });
    }
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('rv'); io.unobserve(en.target); } });
      }, { threshold: 0, rootMargin: '0px 0px 120px 0px' });
      document.querySelectorAll('.sec-title,.sec-sub,.product-card,.perk-list li,.founders-card,.faq-item,.filter-row,.final-cta h2,.fbt-item,.how-step,.rev-card').forEach(function (el, i) {
        el.classList.add('rv-init');
        el.style.transitionDelay = (i % 4) * 60 + 'ms';
        io.observe(el);
      });
      /* safety: never leave content invisible if IO stalls or misses (short pages, bfcache) */
      setTimeout(function () { document.querySelectorAll('.rv-init:not(.rv)').forEach(function (el) { el.classList.add('rv'); }); }, 1500);
    }
  });

  /* magic links: ?add=VARIANT_ID&qty=N lands, adds, opens the drawer (TikTok bio/ads, email, SMS) */
  safe(function () {
    var q = new URLSearchParams(location.search);
    var v = q.get('add');
    if (v && /^\d+$/.test(v)) {
      try { sessionStorage.setItem('tuckGate', '1'); } catch (e) {} /* skip the gate — they came to buy */
      gateDone = true;
      addToCart(v, Math.max(1, Number(q.get('qty')) || 1), q.get('onetime') ? null : defaultSub());
    }
  });

  /* ── consolidated products (Strength × Flavor × Pack): PDP built from #pdpData JSON ── */
  function handleize(x) { return String(x).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  /* '80mg' -> 'Regular \u00b7 80mg'; '160mg Extra Strength' -> 'Extra Strength \u00b7 160mg' */
  function doseLabel(s) { var mg = String(s).split(' ')[0]; return (/extra/i.test(s) ? 'Extra Strength \u00b7 ' : 'Regular \u00b7 ') + mg; }
  safe(function initConsolidatedPdp() {
    var dataEl = $('pdpData'); if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var opts = data.options, vs = data.variants;
    var iS = opts.indexOf('Strength'), iF = opts.indexOf('Flavor'), iP = opts.indexOf('Pack');
    if (iF < 0) return;
    function distinct(i) { var seen = [], out = []; vs.forEach(function (v) { if (seen.indexOf(v.o[i]) < 0) { seen.push(v.o[i]); out.push(v.o[i]); } }); return out; }
    var first = vs.filter(function (v) { return v.a; })[0] || vs[0];
    var sel = { S: iS > -1 ? first.o[iS] : null, F: first.o[iF], P: iP > -1 ? '5-Pack' : null };
    /* flavor hex map mirrors the .lc-dot swatch colors in tuck.css */
    var FLAV_HEX = { 'cool-mint': '#5FA8DC', 'spearmint': '#4CC98A', 'peppermint': '#E05252', 'wintergreen': '#2E9E63', 'coffee': '#8B5E3C', 'mango': '#F2C14E', 'watermelon': '#FF6B81', 'berry-blast': '#8E4BD0', 'blue-raspberry': '#2E86C8' };
    function ak() { return (iS > -1 && T.akMap && T.akMap[sel.S]) || data.ak; }
    function find() { return vs.filter(function (v) { return (iS < 0 || v.o[iS] === sel.S) && v.o[iF] === sel.F && (iP < 0 || v.o[iP] === sel.P); })[0]; }
    function slide(n) { return av(T.assetBase + 'pdp-' + ak() + '-' + handleize(sel.F) + '-' + n + '.webp'); }
    var dr = $('pdpDoses');
    if (dr && iS > -1) {
      dr.innerHTML = distinct(iS).map(function (s) {
        return '<button type="button" class="evar dpill' + (s === sel.S ? ' on' : '') + '" data-os="' + s + '">' + doseLabel(s) + '</button>';
      }).join('');
    }
    var fg = $('pdpFlavors');
    function buildTiles() {
      fg.innerHTML = distinct(iF).map(function (f) {
        var h = handleize(f);
        return '<button type="button" class="evar flav-tile' + (f === sel.F ? ' on' : '') + '" data-of="' + f + '"><img class="ft-img" src="' + av(T.assetBase + ak() + '-' + h + '.png') + '" alt="" aria-hidden="true"><span>' + f + '</span></button>';
      }).join('');
    }
    buildTiles();
    /* 3-tier pack selector: Single / 5-Pack (default, badged) / 10-Pack */
    var TIER_META = { 'Single Can': { name: 'Single', cans: 1 }, '5-Pack': { name: '5-Pack', cans: 5, badge: 'Most popular' }, '10-Pack': { name: '10-Pack', cans: 10, badge: 'Best value' } };
    var tr = $('packTiers');
    function packVariant(p) { return vs.filter(function (v) { return (iS < 0 || v.o[iS] === sel.S) && v.o[iF] === sel.F && v.o[iP] === p; })[0]; }
    function buildTiers() {
      if (!tr || iP < 0) return;
      var order = ['Single Can', '5-Pack', '10-Pack'].filter(function (p) { return distinct(iP).indexOf(p) > -1; });
      tr.innerHTML = order.map(function (p) {
        var v = packVariant(p); if (!v) return '';
        var m = TIER_META[p] || { name: p, cans: 1 };
        var v1 = packVariant('Single Can');
        var save = (m.cans > 1 && v1 && v1.p) ? Math.round(100 * (1 - (v.p / m.cans) / v1.p)) : 0;
        return '<button type="button" class="evar tier' + (p === sel.P ? ' on' : '') + '" data-op="' + p + '">'
          + (m.badge ? '<i class="t-badge">' + m.badge + '</i>' : '')
          + '<b>' + m.name + '</b><span class="t-price">' + money(v.p) + '</span><em>' + money2(v.p / m.cans) + ' / can' + (save > 0 ? ' · save ' + save + '%' : '') + '</em></button>';
      }).join('');
    }
    buildTiers();
    function apply() {
      var v = find(); if (!v) return;
      var hid = $('pdpVariantId'); if (hid) hid.value = v.id;
      var perEl = document.querySelector('.pdp-info .per');
      if (perEl) perEl.textContent = sel.P === 'Single Can' ? '/ can' : '/ ' + String(sel.P).toLowerCase();
      buildTiers();
      syncSubPrices(money(v.p));
      var sp = $('stickyPrice'); if (sp) sp.textContent = money(v.p);
      var dn = $('doseName'); if (dn && iS > -1) dn.textContent = doseLabel(sel.S);
      var fn = $('flavName'); if (fn) fn.textContent = sel.F;
      var line = $('pdpStrengthLine'); if (line && iS > -1) line.textContent = sel.S.split(' ')[0] + ' caffeine · 20 pouches per can';
      var atc = $('pdpAddBtn'); if (atc) { atc.disabled = !v.a; atc.textContent = v.a ? 'Add to cart' : 'Sold out — notify me'; }
      /* subscriptions are 5/10-pack only: a single forces one-time */
      var subOpt = document.querySelector('.sub-opt[data-sub="1"]'), oneOpt = document.querySelector('.sub-opt[data-sub="0"]');
      if (subOpt && iP > -1) {
        var single = sel.P === 'Single Can';
        subOpt.classList.toggle('sub-locked', single);
        if (single && subOpt.classList.contains('on')) {
          subOpt.classList.remove('on'); if (oneOpt) { oneOpt.classList.add('on'); var r0 = oneOpt.querySelector('input'); if (r0) r0.checked = true; }
        }
        if (!single && !subOpt.classList.contains('on') && !subOpt.dataset.userOptedOut) {
          subOpt.classList.add('on'); if (oneOpt) oneOpt.classList.remove('on'); var r1 = subOpt.querySelector('input'); if (r1) r1.checked = true;
        }
        applySubPrice(); syncPlanInput();
      }
      /* photo deck: puck / 5-pack / 10-pack per flavor; active slide locked to the tier */
      var base = ak() + '-' + handleize(sel.F);
      var puck = av(T.assetBase + base + '.png');
      var pdpRoot = document.querySelector('.pdp');
      if (pdpRoot) pdpRoot.style.setProperty('--pfc', FLAV_HEX[handleize(sel.F)] || '#5FA8DC');
      function fadeSrc(im, src) {
        if (!im || im.getAttribute('src') === src) return;
        im.style.opacity = '0.2';
        var d = function () { im.style.opacity = ''; im.removeEventListener('load', d); };
        im.addEventListener('load', d); im.src = src;
      }
      var gs0 = document.querySelector('#pdpTrack .gs0');
      var gs1 = document.querySelector('#pdpTrack .gs1');
      var gs2 = document.querySelector('#pdpTrack .gs2');
      if (gs0) fadeSrc(gs0, puck);
      if (gs1) { gs1.onerror = function () { this.onerror = null; this.src = puck; }; fadeSrc(gs1, av(T.assetBase + 'pack5b-' + base + '.webp')); }
      if (gs2) { gs2.onerror = function () { this.onerror = null; this.src = puck; }; fadeSrc(gs2, av(T.assetBase + 'pack10b-' + base + '.webp')); }
      var th = $('psThumbs');
      if (th) {
        var srcs = [gs0 && gs0.src, gs1 && gs1.src, gs2 && gs2.src];
        Array.prototype.forEach.call(th.children, function (t, i) {
          var im = t.querySelector('img'); if (!im || !srcs[i]) return;
          im.src = srcs[i];
        });
      }
      var slideIdx = sel.P === '10-Pack' ? 2 : (sel.P === '5-Pack' ? 1 : 0);
      var pc = document.getElementById('packCount');
      if (pc) {
        if (slideIdx > 0) { pc.textContent = (slideIdx === 2 ? '10' : '5') + ' cans'; pc.hidden = false; }
        else pc.hidden = true;
      }
      try { document.dispatchEvent(new CustomEvent('tuck:goslide', { detail: slideIdx })); } catch (err) {}
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var d = e.target.closest('#pdpDoses .dpill'); if (d) { sel.S = d.dataset.os; buildTiles(); apply(); return; }
      var f = e.target.closest('#pdpFlavors .flav-tile'); if (f) { sel.F = f.dataset.of; apply(); return; }
      var p = e.target.closest('#packTiers .tier'); if (p && iP > -1) { sel.P = p.dataset.op; sel.userPicked = true; apply(); }
    });
    apply();
  });

  /* consolidated catalog cards: dose pills swap price, dots swap render, add resolves the 5-Pack variant */
  safe(function initConsolidatedCards() {
    document.querySelectorAll('script.cardData').forEach(function (dataEl) {
      var card = dataEl.closest('.product-card'); if (!card) return;
      var data = JSON.parse(dataEl.textContent);
      var opts = data.options, vs = data.variants;
      var iS = opts.indexOf('Strength'), iF = opts.indexOf('Flavor'), iP = opts.indexOf('Pack');
      if (iF < 0) return;
      var first = vs.filter(function (v) { return v.a; })[0] || vs[0];
      var sel = { S: iS > -1 ? first.o[iS] : null, F: first.o[iF] };
      function ak() { return (iS > -1 && T.akMap && T.akMap[sel.S]) || data.ak; }
      function find() { return vs.filter(function (v) { return (iS < 0 || v.o[iS] === sel.S) && v.o[iF] === sel.F && (iP < 0 || v.o[iP] === '5-Pack'); })[0]; }
      function canPrice() { var v5 = find(); return v5 ? v5.p / 5 : 0; }
      function apply() {
        var v = find(); if (!v) return;
        var img = card.querySelector('.prod-img');
        if (img) { var src = av(T.assetBase + ak() + '-' + handleize(sel.F) + '.png'); img.style.opacity = 0; setTimeout(function () { img.src = src; img.onload = function () { img.style.opacity = 1; }; }, 140); }
        var pn = card.querySelector('.price-now'); if (pn) pn.textContent = money(v.p);
        var lc = card.querySelector('.lc-can'); if (lc) lc.textContent = money(canPrice()) + ' / can';
        var lf = card.querySelector('.lc-flavor'); if (lf) lf.innerHTML = sel.F + ' <em>· 9 flavors</em>';
        var add = card.querySelector('.card-add'); if (add) { add.dataset.add = v.id; add.disabled = !v.a; }
        var lk = card.querySelector('h3 a'); if (lk) lk.href = data.url + '?variant=' + v.id;
      }
      card.addEventListener('click', function (e) {
        var d = e.target.closest('.dpill'); if (d && d.dataset.os) { sel.S = d.dataset.os; card.querySelectorAll('.dpill').forEach(function (b) { b.classList.toggle('on', b === d); }); apply(); return; }
        var dot = e.target.closest('.lc-dot'); if (dot) { sel.F = dot.dataset.of; card.querySelectorAll('.lc-dot').forEach(function (b) { b.classList.toggle('on', b === dot); }); apply(); }
      });
      apply();
    });
  });

  /* V3: subtle scroll reveals */
  function initReveals() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.line-card, .nze-card, .shift, .compare .compare-table, .stats .stat, .rev-card, .faq-item, .how-step, .fbt-item, .pdp-reviews .rev-card');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 100px 0px' });
    els.forEach(function (el) { if (el.classList.contains('rv')) return; el.classList.add('rv'); io.observe(el); });
    /* safety: never leave content hidden if IO stalls (backgrounded tabs, odd embeds) */
    setTimeout(function () { document.querySelectorAll('.rv:not(.in)').forEach(function (el) { el.classList.add('in'); }); }, 2500);
  }
  safe(initReveals);
  window.TUCKReveal = initReveals;

  /* V3: hero cursor parallax tilt (desktop, motion-safe) — homepage hero + PDP puck */
  safe(function initPdpTilt() {
    var stage = document.querySelector('.pdp-media');
    if (!stage) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      stage.querySelectorAll('.pdp-slide img').forEach(function (im) {
        var k = im.classList.contains('prod-img') ? 1 : 0.55;
        im.style.transform = 'rotateY(' + (x * 14 * k) + 'deg) rotateX(' + (-y * 10 * k) + 'deg) scale(1.02)';
      });
    });
    stage.addEventListener('mouseleave', function () {
      stage.querySelectorAll('.pdp-slide img').forEach(function (im) { im.style.transform = ''; });
    });
  });
  safe(function initTilt() {
    var stage = $('heroStage'), can = $('canScroll');
    if (!stage || !can) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      can.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 10) + 'deg)';
    });
    stage.addEventListener('mouseleave', function () { can.style.transform = ''; });
  });

  /* shop filter: sliding ink indicator behind the active pill */
  safe(function initFiltInd() {
    var row = document.getElementById('filterRow'); if (!row) return;
    var ind = row.querySelector('.filt-ind'); if (!ind) return;
    function place() {
      var on = row.querySelector('.filt.on'); if (!on) return;
      ind.style.left = on.offsetLeft + 'px'; ind.style.top = on.offsetTop + 'px';
      ind.style.width = on.offsetWidth + 'px'; ind.style.height = on.offsetHeight + 'px';
      ind.style.opacity = '1';
    }
    window.TUCKFiltInd = place;
    window.addEventListener('resize', place);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    setTimeout(place, 60);
  });

  /* category cards: gentle scroll parallax on the cans */
  safe(function initCatParallax() {
    var cans = document.querySelectorAll('.shift .shift-can');
    if (!cans.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var tick = false;
    function upd() {
      tick = false;
      cans.forEach(function (c) {
        var card = c.closest('.shift'); if (!card) return;
        var r = card.getBoundingClientRect();
        if (r.bottom < -80 || r.top > innerHeight + 80) return;
        var pr = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        c.style.translate = '0 ' + (pr * 26).toFixed(1) + 'px';
      });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  });

  /* V3: card flavor dots tint the stage disc */
  document.addEventListener('click', function (e) {
    var d = e.target.closest('.lc-dot'); if (!d) return;
    var tin = d.closest('.product-card, .line-card'); tin = tin && tin.querySelector('.line-tin, .tin-img');
    if (tin) tin.style.setProperty('--fc', getComputedStyle(d).backgroundColor);
  });

  safe(function () { if ($('subToggle')) { applySubPrice(); syncPlanInput(); } });
  safe(applyOfferState);
  window.TUCKOffer = applyOfferState; /* pages that build cards after load re-apply the offer state */
  safe(initGate);
  safe(refreshCart);
})();
